export default __webpack_public_path__ + "static/EverydayPerformanceBehaviour3-3bb9d1d389251e21466d6e45eeab0721.png";